import styled from "styled-components";

export const Panel = styled.div`
  position: relative;
  overflow: hidden;
  background: #fff;
  color: var(--auth-text-primary);
  border-right: 1px solid var(--auth-card-border);
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  padding: 44px 52px;

  @media (max-width: 900px) {
    display: none;
  }
`;

export const Glow = styled.span<{ variant: "top" | "bottom" }>`
  position: absolute;
  border-radius: 50%;
  pointer-events: none;

  ${({ variant }) =>
    variant === "top"
      ? `
    top: -120px;
    right: -90px;
    width: 360px;
    height: 360px;
    background: radial-gradient(circle, rgba(242, 99, 38, 0.12), transparent 68%);
  `
      : `
    bottom: -140px;
    left: -80px;
    width: 320px;
    height: 320px;
    background: radial-gradient(circle, rgba(255, 145, 41, 0.10), transparent 70%);
  `}
`;

export const Logo = styled.img`
  position: relative;
  height: 34px;
  width: auto;
  align-self: flex-start;
`;

export const Middle = styled.div`
  position: relative;
  max-width: 440px;
`;

export const Badge = styled.div`
  display: inline-flex;
  align-items: center;
  gap: 8px;
  background: rgba(242, 99, 38, 0.10);
  color: var(--auth-accent);
  font-size: 13px;
  font-weight: 600;
  padding: 7px 14px;
  border-radius: 999px;
  margin-bottom: 26px;

  span {
    width: 7px;
    height: 7px;
    border-radius: 50%;
    background: var(--auth-accent);
  }
`;

export const Title = styled.h1`
  font-family: "Montserrat", sans-serif;
  font-weight: 800;
  font-size: 46px;
  line-height: 1.04;
  letter-spacing: -0.035em;
  margin: 0 0 18px;
  text-wrap: balance;
  color: var(--auth-text-primary);

  span {
    color: var(--auth-accent);
  }
`;

export const Description = styled.p`
  font-size: 17px;
  line-height: 1.6;
  color: var(--auth-text-secondary);
  margin: 0 0 34px;
`;

export const PerkList = styled.div`
  display: flex;
  flex-direction: column;
  gap: 14px;
`;

export const Perk = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
  font-size: 15px;
  font-weight: 500;
  color: var(--auth-text-primary);

  span {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: 24px;
    height: 24px;
    border-radius: 50%;
    background: rgba(242, 99, 38, 0.12);
    color: var(--auth-accent);
    font-size: 12px;
    font-weight: 800;
    flex-shrink: 0;
  }
`;

export const Footer = styled.div`
  position: relative;
  font-size: 13px;
  color: var(--auth-text-footer);
`;
